export function formatNewAccountSMS(username = "") {
    return `Your transportation account has been created for ${username}.`;
}

export const autoScheduleFailedSMS = `We can't schedule your requested trip right now due to availability. Please try again later or contact support for assistance.`;
